$(document).ready(function () {
  
  // prestige_gift_set



  $(".coll_parent").on("change", function () {
    var selected_value = $(this).val();

    $(this)
      .siblings(".inner_product")
      .each(function () {
        var inner_items = $(this).attr("dta_collection");

        if (selected_value == inner_items) {
          $(this).removeClass("hidden_ctm");
          $(this).addClass("view_ctm");
          $(this).siblings(".only_item").addClass("hidden_ctm");
        } else {
          $(this).addClass("hidden_ctm");
          $(this).removeClass("view_ctm");
        }
        if (selected_value == "Collection") {
          $(this).siblings(".only_item").removeClass("hidden_ctm");
        }
      });

    $(this).siblings().prop("selectedIndex", 0);
  });


// function formatMoney(cents, format = "") {
// 	if (typeof cents === "string") {
// 		cents = cents.replace(".", "");
// 	}
// 	let value = "";
// 	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
// 	const formatString = format || theme.moneyFormat;
// 	function formatWithDelimiters(
// 		number,
// 		precision = 2,
// 		thousands = ",",
// 		decimal = "."
// 	) {
// 		if (isNaN(number) || number == null) {
// 			return 0;
// 		}

// 		number = (number / 100.0).toFixed(precision);

// 		const parts = number.split(".");
// 		const dollarsAmount = parts[0].replace(
// 			/(\d)(?=(\d\d\d)+(?!\d))/g,
// 			`$1${thousands}`
// 		);
// 		const centsAmount = parts[1] ? decimal + parts[1] : "";

// 		return dollarsAmount + centsAmount;
// 	}

// 	switch (formatString.match(placeholderRegex)[1]) {
// 		case "amount":
// 			value = formatWithDelimiters(cents, 2);
// 			break;
// 		case "amount_no_decimals":
// 			value = formatWithDelimiters(cents, 0);
// 			break;
// 		case "amount_with_comma_separator":
// 			value = formatWithDelimiters(cents, 2, ".", ",");
// 			break;
// 		case "amount_no_decimals_with_comma_separator":
// 			value = formatWithDelimiters(cents, 0, ".", ",");
// 			break;
// 	}

// 	return formatString.replace(placeholderRegex, value);
// }
  
  function updateTotalPrice() {
    var price1 =
      parseInt($(".pro_set_1.view_ctm").find(":selected").attr("pres_price"), 10) || 0;
    var price2 =
      parseInt($(".pro_set_2.view_ctm").find(":selected").attr("pres_price"), 10) || 0;

    var totalPrice = price1 + price2;
    var n = totalPrice / 100;
    var formattedPrice = n.toLocaleString("en-hk", {
      style: "currency",
      currency: "SAR",
      
    });
    console.log(formattedPrice);
    $(".ctm_price").html(formattedPrice);
  }

  
  
  $(".first_collect").on("change", function () {
    var seleValue_1 = $(this).val();
    var selected_2;
    $(".second_collect").each(function () {
      selected_2 = $(this).find(":selected").val();
    });
    if (seleValue_1 == "Collection" && selected_2 == "Collection") {
      $(".figure_pareent").hide();
      if ($(window).width() < 700) {
        $(".ctm_prestige_set .product__media-item").show();
      }
    }
    $(".selected-item-1").css("opacity", "0");

    updateTotalPrice();
  });


  
  $(".second_collect").on("change", function () {
    var seleValue_2 = $(this).val();
    var selected_1;
    $(".first_collect").each(function () {
      selected_1 = $(this).find(":selected").val();
    });
    if (seleValue_2 == "Collection" && selected_1 == "Collection") {
      $(".figure_pareent").hide();
      if ($(window).width() < 700) {
        $(".ctm_prestige_set .product__media-item").show();
      }
    }
    $(".selected-item-2").css("opacity", "0");

    updateTotalPrice();
  });



  
  $(".pro_set_1").on("change", function () {
    var first_vl_at = $(this).val();
    var second_selected_value;

    $(".pro_set_2").each(function () {
      second_selected_value = $(this).find(":selected").val();
    });

    var sourceAttrFirst = $(this).find(":selected").attr("prestiage_source");
    $(".selected-item-1").attr("src", sourceAttrFirst);

    if (first_vl_at == "Item" && second_selected_value == "Item") {
      $(".figure_pareent").hide();
      if ($(window).width() < 700) {
        $(".ctm_prestige_set .product__media-item").show();
      }
    } else if (sourceAttrFirst) {
      $(".figure_pareent").show();
      if ($(window).width() < 700) {
        $(".ctm_prestige_set .product__media-item").hide();
      }
    }

    if (first_vl_at == "Item") {
      $(".selected-item-1").css("opacity", "0");
    } else {
      $(".selected-item-1").css("opacity", "1");
    }

    updateTotalPrice();
  });


  
  $(".pro_set_2").on("change", function () {
    var second_vl_at = $(this).val();
    var first_selected_value;

    $(".pro_set_1").each(function () {
      first_selected_value = $(this).find(":selected").val();
    });

    var sourceAttrSecond = $(this).find(":selected").attr("prestiage_source");
    $(".selected-item-2").attr("src", sourceAttrSecond);

    if (second_vl_at == "Item" && first_selected_value == "Item") {
      $(".figure_pareent").hide();
      if ($(window).width() < 700) {
        $(".ctm_prestige_set .product__media-item").show();
      }
    } else if (sourceAttrSecond) {
      $(".figure_pareent").show();
      if ($(window).width() < 700) {
        $(".ctm_prestige_set .product__media-item").hide();
      }
    }

    if (second_vl_at == "Item") {
      $(".selected-item-2").css("opacity", "0");
    } else {
      $(".selected-item-2").css("opacity", "1");
    }

    updateTotalPrice();
  });


 
  $(document).on("change", ".variant_change_option", function () {
    var image_source = $(this).find(":selected").attr("variant_img");
    $(".ctm_vrnt_image").each(function () {
      var variant_image = $(this).attr("data_variant_images");
      
      // if ($(window).width() < 700) {
        if (image_source == variant_image) {
          $(this).show();
          if ($(window).width() >= 700) {
            this.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        } else {
          $(this).hide();
        }
      // }
    });
  });


  
  $(".ctm_btn_add_gift").on("click", function () {
    var selectedProductId = [];
    var properties = {};
    var mian_product_ids = null;
    var def_pro_id = $(".gift_set_prestiage_parent").attr("defualt_product_id");
    var def_attr_label = $(".gift_set_prestiage_parent").attr("data_label");
    var def_value_attr = $(".gift_set_prestiage_parent").attr("value");

    $(".inner_product").each(function () {
      var selectedOption = $(this).find(":selected");
      var val_option = selectedOption.val();
      var label_attr = selectedOption.attr("data_label");
      var proId = selectedOption.attr("data_pro_id");
      var mainProductId = selectedOption.attr("main_product_var_id");

      if (proId) {
        selectedProductId.push(proId);
        properties[label_attr] = val_option;
      }

      if (!mian_product_ids && mainProductId) {
        mian_product_ids = mainProductId;
        properties[label_attr] = val_option;
      }
    });

    var mainProductToUse = mian_product_ids ? mian_product_ids : def_pro_id;

    if (!selectedProductId.includes(mainProductToUse)) {
      selectedProductId.push(mainProductToUse);
      properties[def_attr_label] = def_value_attr;
    }

    let items = selectedProductId.map((id) => ({
      id: parseInt(id),
      quantity: 1,
      properties: {
        ...(id == mainProductToUse ? properties : {}),
        "Random Number": Math.random() * 10,
      },
    }));

    console.log(items);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then((response) => {
        window.location = "/cart";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });


  
  // heritage_gift_box

 
  
  function updateTotalPriceHer() {
    var price1 =
      parseInt(
        $(".first_product_element").find(":selected").attr("pres_price"),
        10
      ) || 0;
    var price2 =
      parseInt(
        $(".second_product_element").find(":selected").attr("pres_price"),
        10
      ) || 0;
    var price3 =
      parseInt(
        $(".third_product_element").find(":selected").attr("pres_price"),
        10
      ) || 0;
    var price4 =
      parseInt(
        $(".fourth_product_element").find(":selected").attr("pres_price"),
        10
      ) || 0;
    var price5 =
      parseInt(
        $(".fifth_product_element").find(":selected").attr("pres_price"),
        10
      ) || 0;

    var totalPrice = price1 + price2 + price3 + price4 + price5;
    var n = totalPrice / 100;
    var formattedPriceHer = n.toLocaleString("en-US", {
      style: "currency",
      currency: "SAR",
    });

    $(".ctm_heritage_price").html(formattedPriceHer);
  }


  
  $(".first_product_element").on("change", function () {
    var select_value_first = $(this).val();

    var Check_value_item_1;
    var Check_value_item_2;
    var Check_value_item_3;
    var Check_value_item_4;

    $(".second_product_element").each(function () {
      Check_value_item_1 = $(this).find(":selected").val();
    });

    $(".third_product_element").each(function () {
      Check_value_item_2 = $(this).find(":selected").val();
    });

    $(".fourth_product_element").each(function () {
      Check_value_item_3 = $(this).find(":selected").val();
    });

    $(".fifth_product_element").each(function () {
      Check_value_item_4 = $(this).find(":selected").val();
    });

    var heritageAttrFirst = $(this).find(":selected").attr("heritage_source");
    $(".frist_product_source").attr("src", heritageAttrFirst);

    if (select_value_first == "Item") {
      $(".frist_product_source").css("opacity", "0");
    } else {
      $(".frist_product_source").css("opacity", "1");
    }

    if (
      select_value_first == "Item" &&
      Check_value_item_1 == "Item" &&
      Check_value_item_2 == "Item" &&
      Check_value_item_3 == "Item" &&
      Check_value_item_4 == "Item"
    ) {
      $(".haeritage_source_media").hide();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").show();
      }
    } else if (heritageAttrFirst) {
      $(".haeritage_source_media").show();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").hide();
      }
    }

    updateTotalPriceHer();
  });


  
  $(".second_product_element").on("change", function () {
    var select_value_second = $(this).val();

    $(this)
      .siblings(".third_product_element")
      .find("option")
      .each(function () {
        var innerItems = $(this).val();

        if (select_value_second == innerItems && innerItems != "Item") {
          $(this).prop("disabled", true);
        } else {
          $(this).prop("disabled", false);
        }
      });

    var Check_value_item_1;
    var Check_value_item_2;
    var Check_value_item_3;
    var Check_value_item_4;

    $(".first_product_element").each(function () {
      Check_value_item_1 = $(this).find(":selected").val();
    });

    $(".third_product_element").each(function () {
      Check_value_item_2 = $(this).find(":selected").val();
    });

    $(".fourth_product_element").each(function () {
      Check_value_item_3 = $(this).find(":selected").val();
    });

    $(".fifth_product_element").each(function () {
      Check_value_item_4 = $(this).find(":selected").val();
    });

    var heritageAttrSecond = $(this).find(":selected").attr("heritage_source");
    $(".second_product_source").attr("src", heritageAttrSecond);

    if (select_value_second == "Item") {
      $(".second_product_source").css("opacity", "0");
    } else {
      $(".second_product_source").css("opacity", "1");
    }

    if (
      select_value_second == "Item" &&
      Check_value_item_1 == "Item" &&
      Check_value_item_2 == "Item" &&
      Check_value_item_3 == "Item" &&
      Check_value_item_4 == "Item"
    ) {
      $(".haeritage_source_media").hide();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").show();
      }
    } else if (heritageAttrSecond) {
      $(".haeritage_source_media").show();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").hide();
      }
    }

    updateTotalPriceHer();
  });


  
  $(".third_product_element").on("change", function () {
    var select_value_third = $(this).val();

    $(this)
      .siblings(".second_product_element")
      .find("option")
      .each(function () {
        var innerItems = $(this).val();

        if (select_value_third == innerItems && innerItems != "Item") {
          $(this).prop("disabled", true);
        } else {
          $(this).prop("disabled", false);
        }
      });

    var Check_value_item_1;
    var Check_value_item_2;
    var Check_value_item_3;
    var Check_value_item_4;

    $(".first_product_element").each(function () {
      Check_value_item_1 = $(this).find(":selected").val();
    });

    $(".second_product_element").each(function () {
      Check_value_item_2 = $(this).find(":selected").val();
    });

    $(".fourth_product_element").each(function () {
      Check_value_item_3 = $(this).find(":selected").val();
    });

    $(".fifth_product_element").each(function () {
      Check_value_item_4 = $(this).find(":selected").val();
    });

    var heritageAttrThrid = $(this).find(":selected").attr("heritage_source");
    $(".third_product_source").attr("src", heritageAttrThrid);

    if (select_value_third == "Item") {
      $(".third_product_source").css("opacity", "0");
    } else {
      $(".third_product_source").css("opacity", "1");
    }

    if (
      select_value_third == "Item" &&
      Check_value_item_1 == "Item" &&
      Check_value_item_2 == "Item" &&
      Check_value_item_3 == "Item" &&
      Check_value_item_4 == "Item"
    ) {
      $(".haeritage_source_media").hide();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").show();
      }
    } else if (heritageAttrThrid) {
      $(".haeritage_source_media").show();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").hide();
      }
    }

    updateTotalPriceHer();
  });


  
  $(".fourth_product_element").on("change", function () {
    var select_value_fourth = $(this).val();

    $(this)
      .siblings(".fifth_product_element")
      .find("option")
      .each(function () {
        var innerItems = $(this).val();

        if (select_value_fourth == innerItems && innerItems != "Item") {
          $(this).prop("disabled", true);
        } else {
          $(this).prop("disabled", false);
        }
      });

    var Check_value_item_1;
    var Check_value_item_2;
    var Check_value_item_3;
    var Check_value_item_4;

    $(".first_product_element").each(function () {
      Check_value_item_1 = $(this).find(":selected").val();
    });

    $(".second_product_element").each(function () {
      Check_value_item_2 = $(this).find(":selected").val();
    });

    $(".third_product_element").each(function () {
      Check_value_item_3 = $(this).find(":selected").val();
    });

    $(".fifth_product_element").each(function () {
      Check_value_item_4 = $(this).find(":selected").val();
    });

    var heritageAttrFourth = $(this).find(":selected").attr("heritage_source");
    $(".fouth_product_source").attr("src", heritageAttrFourth);

    if (select_value_fourth == "Item") {
      $(".fouth_product_source").css("opacity", "0");
    } else {
      $(".fouth_product_source").css("opacity", "1");
    }

    if (
      select_value_fourth == "Item" &&
      Check_value_item_1 == "Item" &&
      Check_value_item_2 == "Item" &&
      Check_value_item_3 == "Item" &&
      Check_value_item_4 == "Item"
    ) {
      $(".haeritage_source_media").hide();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").show();
      }
    } else if (heritageAttrFourth) {
      $(".haeritage_source_media").show();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").hide();
      }
    }

    updateTotalPriceHer();
  });


  
  $(".fifth_product_element").on("change", function () {
    var select_value_fifth = $(this).val();

    $(this)
      .siblings(".fourth_product_element")
      .find("option")
      .each(function () {
        var innerItems = $(this).val();

        if (select_value_fifth == innerItems && innerItems != "Item") {
          $(this).prop("disabled", true);
        } else {
          $(this).prop("disabled", false);
        }
      });

    var Check_value_item_1;
    var Check_value_item_2;
    var Check_value_item_3;
    var Check_value_item_4;

    $(".first_product_element").each(function () {
      Check_value_item_1 = $(this).find(":selected").val();
    });

    $(".second_product_element").each(function () {
      Check_value_item_2 = $(this).find(":selected").val();
    });

    $(".third_product_element").each(function () {
      Check_value_item_3 = $(this).find(":selected").val();
    });

    $(".fourth_product_element").each(function () {
      Check_value_item_4 = $(this).find(":selected").val();
    });

    var heritageAttrFifth = $(this).find(":selected").attr("heritage_source");
    $(".fifth_product_source").attr("src", heritageAttrFifth);

    if (select_value_fifth == "Item") {
      $(".fifth_product_source").css("opacity", "0");
    } else {
      $(".fifth_product_source").css("opacity", "1");
    }

    if (
      select_value_fifth == "Item" &&
      Check_value_item_1 == "Item" &&
      Check_value_item_2 == "Item" &&
      Check_value_item_3 == "Item" &&
      Check_value_item_4 == "Item"
    ) {
      $(".haeritage_source_media").hide();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").show();
      }
    } else if (heritageAttrFifth) {
      $(".haeritage_source_media").show();
      if ($(window).width() < 700) {
        $(".ctm_heritge_box .product__media-item").hide();
      }
    }

    updateTotalPriceHer();
  });


  
  $(".heritage_btn_ctm").on("click", function () {
    var multipleProductId = [];
    var properties = {};
    var mian_product_ids = null;
    var def_pro_id = $(".gift_set_prestiage_parent").attr("defualt_product_id");
    var def_attr_label = $(".gift_set_prestiage_parent").attr("data_label");
    var def_value_attr = $(".gift_set_prestiage_parent").attr("value");

    $(".heri_selected_at").each(function () {
      var selectedOptionHeri = $(this).find(":selected");
      var proIdHeri = selectedOptionHeri.attr("product_aval_id");
      var val_option = selectedOptionHeri.val();
      var label_attr = selectedOptionHeri.attr("data_label");
      var mainProductVarId = selectedOptionHeri.attr("product_aval_variant_id");

      if (proIdHeri) {
        multipleProductId.push(proIdHeri);
        properties[label_attr] = val_option;
      }

      if (!mian_product_ids && mainProductVarId) {
        mian_product_ids = mainProductVarId;
        properties[label_attr] = val_option;
      }
    });

    var mainProductToUse = mian_product_ids ? mian_product_ids : def_pro_id;

    if (!multipleProductId.includes(mainProductToUse)) {
      multipleProductId.push(mainProductToUse);
      properties[def_attr_label] = def_value_attr;
    }

    let items = multipleProductId.map((id) => ({
      id: parseInt(id),
      quantity: 1,
      properties: {
        ...(id == mainProductToUse ? properties : {}),
        "Random Number": Math.random() * 10,
      },
    }));

    console.log(items);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then((response) => {
        window.location = "/cart";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });


  
  // cart update.js


  
  $(".ctm_cart_item_remove").on("click", function () {
    var getAllIDs = [];

    $(".cart-item").each(function () {
      var productOption = $(this).find(".name_option").last().text().trim();
      var ItemId = $(this).find(".cart-item__media").attr("data_id");

      if (productOption === "Random Number:") {
        getAllIDs.push(ItemId);
      }
    });

    let updates = {};
    getAllIDs.forEach((id) => {
      updates[id] = 0;
    });

    console.log(updates);

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });


  
  // cart change.js



  $(document).on("click", ".qtybox .btnqty", function () {
    let $qtyBox = $(this).closest(".qtybox");
    let $input = $qtyBox.find(".ctm_quantity_change");
    let qty = parseInt($input.val()) || 1;

    if ($(this).hasClass("qtyplus")) {
      qty++;
    } else if (qty > 1) {
      qty--;
    }

    $input.val(qty).trigger("change");
  });


  
  $(document).on("change input", ".ctm_quantity_change", function () {
    var updatedChange = {};
    var quantity_value = parseInt($(this).val());

    $(".cart-item").each(function () {
        var productName = $(this).find(".name_option").last().text().trim();
        var item_id = $(this).find(".cart-item__media").attr("data_id");
        if (productName === "Random Number:" && item_id) {
            updatedChange[item_id] = quantity_value;
          
        }
    });

     console.log(updatedChange); 
     fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: updatedChange }),
        })
        .then((response) => response.json())
        .then((data) => {
            console.log("Cart updated:", data);
        
            window.location.reload();
        })
        .catch((error) => {
            console.error("Error:", error);
        });
  });

  $(document).on("click", ".ctm_lang_text", function (){
    var pareLangSelecter = $(this).closest('.ctm_language_part').siblings('.button-save');
    pareLangSelecter.trigger('click')
  });
  
});
